module.exports = __webpack_public_path__ + "media/packs/images/search/destination-bc2532a03eb1626745c23b080e1be50c.svg";